//-------------------------------------------------------------------------------------------------- Imports
import { Card, Col, Row, Select, Typography } from "antd";
import { StyleSheet } from "../../StyleSheet";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { useCallback, useEffect, useState } from "react";
import Loading from "../../components/Loading";
import { getCallsHistory, getPeriodsCalls } from "../../methods/Methods";
import { useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import _ from "lodash";
import moment from "moment";
import 'moment/locale/es';
import { ResponseCallsLlamada, ResponseCallsPeriodsPeriodo } from "../../types/common";
import InfoCardComponent from "../../components/InfoCardComponent";
const { Text } = Typography;

//-------------------------------------------------------------------------------------------------- View
const CallHistory = () => {
    interface SelectOptObj {
        value: string,
        label: string,
        callObj: ResponseCallsPeriodsPeriodo
    }

    interface SelectOpt {
        value: string,
        label: string,
    }
    const formatter = new Intl.NumberFormat('es-MX', { style: "currency", currency: "MXN" })
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const generalData = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");
    const [typeSelected, setTypeSelected] = useState("AllCalls");
    const [periodSelected, setPeriodSelected] = useState("Seleccione una opción");
    const [callList, setCallList] = useState<Array<ResponseCallsLlamada[]>>([]);
    const [listPeriodsOpt, setListPeriodsOpt] = useState<Array<SelectOptObj>>([]);
    const [hasError, setHasError] = useState(false);
    const [messageInfo, setMessageInfo] = useState("");
    const headersCall = ["Teléfono", "Ubicación", "Duración", "Importe"];

    // Lista de los tipos de llamada
    const typesOfCalls: Array<SelectOpt> = [
        {
            value: 'AllCalls',
            label: 'Todas las Llamadas',
        },
        {
            value: 'LMF',
            label: 'Locales megafón',
        },
        {
            value: 'LOC',
            label: 'Locales otras compañías',
        },
        {
            value: 'CPP',
            label: 'Celular',
        },
        {
            value: 'NLD',
            label: 'Larga distancia nacional',
        },
        {
            value: 'NEA',
            label: 'Larga distancia nacional NEA',
        },
        {
            value: 'ILD',
            label: 'Larga distancia a E.U. y CAN',
        },
        {
            value: 'ROW',
            label: 'Larga distancia otros paises',
        },
        {
            value: '800',
            label: 'Larga distancia sin costo',
        },
        {
            value: 'CNP',
            label: 'Larga distancia celulares',
        },
        {
            value: '???',
            label: 'Desconocidas',
        },
    ];

    const getPeriodsFnt = useCallback(async () => {
        setIsLoading(true);
        await getPeriodsCalls(idCliente)
            .then((response) => {
                if (response.data && response.data.data && response.data.data[0] && response.data.data[0].periodos) {
                    let testData: Array<SelectOptObj> = response.data.data[0].periodos.map((period, index) => ({
                        label: period.fechaInicio + " al " + period.fechaFin,
                        value: index.toString(),
                        callObj: period

                    }))
                    setListPeriodsOpt(testData);
                }
                setIsLoading(false);
            })
            .catch(() => {
                setHasError(true);
                setMessageInfo("Hubo un error al obtener los datos. \nIntente más tarde.");
                setIsLoading(false);
            });
    }, [idCliente]);

    const handleChangeType = (value: string) => {
        setTypeSelected(value);
    };

    const handlePeriod = (item: string) => {
        setPeriodSelected(item);
    };

    const getCallsHistoryFnt = useCallback(async (typeSelected: string, periodSelected: ResponseCallsPeriodsPeriodo) => {
        setIsLoading(true);
        await getCallsHistory(idCliente, periodSelected.fechaInicio, periodSelected.fechaFin, typeSelected)
            .then((response) => {
                if (response.data && response.data.data[0] && response.data.data[0].llamadas) {
                    const sortedCalls = _.orderBy(response.data.data[0].llamadas, "fechaHora", "desc");
                    const groupedCalls = sortedCalls.reduce((groups: { [key: string]: ResponseCallsLlamada[] }, call: ResponseCallsLlamada) => {
                        const date = moment(call.fechaHora).format("LL").toString();
                        if (!groups[date]) {
                            groups[date] = [];
                        }
                        groups[date].push(call);
                        return groups;
                    }, {});
                    const listOfCalls = Object.values(groupedCalls);
                    setCallList(listOfCalls);
                }
                setIsLoading(false);
            })
            .catch(() => {
                setHasError(true);
                setMessageInfo("Hubo un error al realizar la consulta. \nIntente más tarde.");
            });
    }, [idCliente]);

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            setIdCliente(
                generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor
            );
        }
    }, [generalData.selectedContract]);

     // useEffect para obtener los datos de los periodos
     useEffect(() => {
        if (!_.isEmpty(idCliente)) {
            getPeriodsFnt();
        }
    }, [idCliente, getPeriodsFnt]);

    useEffect(() => {
        let periodObj = _.find(listPeriodsOpt, { value: periodSelected });
        if (periodObj) {
            getCallsHistoryFnt(typeSelected, periodObj.callObj)
        }
    }, [periodSelected, getCallsHistoryFnt, listPeriodsOpt, typeSelected])

    return (
        <>
            {
                isLoading ?
                    <Loading />
                    :
                    <SubDefaultLayout title={"Historial de Llamadas"} >
                        {
                            hasError ?
                                <InfoCardComponent title="¡Estimado usuario!" description={messageInfo} />
                                :
                                <>
                                    <div style={{ justifyContent: 'center', display: 'flex' }}>
                                        <Card style={styles.card}>
                                            <Row gutter={[12, 12]}>
                                                <Col span={12}>
                                                    <div style={styles.inputContainer}>
                                                        <Text style={styles.inputTextTitle}>
                                                            Tipo de Llamada
                                                        </Text>
                                                        <Select
                                                            value={typeSelected}
                                                            options={typesOfCalls}
                                                            onChange={handleChangeType}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div style={styles.inputContainer}>
                                                        <Text style={styles.inputTextTitle}>
                                                            Mes
                                                        </Text>
                                                        <Select
                                                            options={listPeriodsOpt.map((period, index) => ({
                                                                label: period.label,
                                                                value: index.toString()
                                                            }))}
                                                            value={periodSelected}
                                                            onChange={handlePeriod}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </div>
                                    {
                                        callList.length > 0 ?
                                            <Card style={styles.cardDetails}>
                                                <Card style={styles.cardHeader} bodyStyle={{ padding: 10 }}>
                                                    <Row>
                                                        {
                                                            headersCall.map((elem) => (
                                                                <Col style={styles.headerView} span={6}>
                                                                    <Text style={{ color: 'white' }}>{elem}</Text>
                                                                </Col>
                                                            ))
                                                        }
                                                    </Row>
                                                </Card>
                                                {
                                                    callList.map((callsByDate) => (
                                                        <div style={styles.divRoot}>
                                                            <div style={styles.divDate}>
                                                                <div style={styles.dateView}>
                                                                    <Text style={styles.dateText}>{moment(callsByDate[0].fechaHora).format("LL")}</Text>
                                                                </div>
                                                            </div>
                                                            <div style={styles.divider} />
                                                            <div style={{ width: "95%" }}>
                                                                {
                                                                    callsByDate.map((call, index) => (
                                                                        <Row key={index}>
                                                                            <Col style={styles.colView} span={6}>
                                                                                <div style={styles.divColumn}>
                                                                                    <Text style={{ fontWeight: 600, textAlign: 'center' }}>{call.llamadaDescripcion}</Text>
                                                                                    <Text style={styles.textData}>{call.destino}</Text>
                                                                                </div>
                                                                            </Col>
                                                                            <Col style={styles.colView} span={6} >
                                                                                <div style={styles.divColumn}>
                                                                                    <Text style={styles.textData}>
                                                                                        {call.pais ? call.pais : ""}
                                                                                    </Text>
                                                                                    <Text style={styles.textData}>
                                                                                        {call.estado}
                                                                                    </Text>
                                                                                    <Text style={styles.textData}>
                                                                                        {call.ciudad}
                                                                                    </Text>
                                                                                </div>
                                                                            </Col>
                                                                            <Col style={styles.colView} span={6}>
                                                                                <Text style={styles.textData}>
                                                                                    {call.duracion}
                                                                                </Text>
                                                                            </Col>
                                                                            <Col style={styles.colView} span={6}>
                                                                                <Text style={styles.textData}>
                                                                                    {formatter.format(Number(call.importe))}
                                                                                </Text>
                                                                            </Col>
                                                                            <div style={styles.dividerCall} />
                                                                        </Row>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </Card>
                                            :
                                            <div style={styles.divNoCalls}>
                                                <Text style={styles.noCalls}>
                                                    No hay llamadas telefónicas
                                                </Text>
                                            </div>
                                    }
                                </>
                        }
                    </SubDefaultLayout>
            }
        </>
    );
};

const styles = StyleSheet.create({
    card: {
        width: "80%",
        borderRadius: 20,
        boxShadow: "0px 0px 8px #00000029",
        padding: "0px 10px",
    },
    cardDetails: {
        width: "100%",
        borderRadius: 20,
        boxShadow: "0px 0px 8px #00000029",
        padding: "0px 10px",
        margin: "20px 0px 20px 0px"
    },
    cardHeader: {
        borderRadius: 20,
        border: "none",
        backgroundColor: "#0055c2",
    },
    headerView: {
        justifyContent: 'center',
        display: 'flex'
    },
    divRoot: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        marginTop: 10
    },
    dateView: {
        backgroundColor: '#d9d9d9',
        borderRadius: 15,
        padding: 5,
    },
    dateText: {
        color: '#3e4245',
        fontWeight: 500,
        fontSize: 13
    },
    divColumn: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column'
    },
    noCalls: {
        fontSize: 18,
        fontWeight: 600,
        marginTop: 15,
        color: "#085bc2",
    },
    divNoCalls: {
        justifyContent: 'center',
        display: 'flex',
    },
    inputTextTitle: {
        fontSize: 15,
        color: "#0e5ea5",
        fontWeight: 500,
        paddingLeft: 5,
        display: 'flex',
        height: 40,
        alignItems: 'center'
    },
    inputContainer: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: "5px",
        marginRight: "5px"
    },
    colView: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 5
    },
    divider: {
        borderBottom: "1px solid #000000",
        width: "95%",
        justifyContent: 'center',
        display: 'flex',
        marginBottom: 10
    },
    dividerCall: {
        borderBottom: "1px solid #000000",
        width: "100%",
    },
    textData: {
        fontSize: 13,
        textAlign: 'center'
    },
    divDate: {
        display: "flex",
        width: "95%",
        alignSelf: 'center'
    }
});

export default CallHistory;
